interface IOtopTextArgs {
  phone: string | null;
  type?: string;
}

export const getOtpText = ({ phone, type }: IOtopTextArgs) => {
  if (!phone?.startsWith('+234')) {
    return `An sms was sent to `;
  }
  if (!type || type.toLowerCase() === 'sms') {
    return `An sms was sent to `;
  }
  return `A call is being placed to `;
};

export const getOtpBottomText = ({ phone, type }: IOtopTextArgs) => {
  if (!phone?.startsWith('+234')) {
    return `Didn't get a text?`;
  }
  if (!type || type.toLowerCase() === 'sms') {
    return `Didn't get a text?`;
  }
  return `Didn't get a call?`;
};
